// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

export const VoucherTicket = styled.div`
  background: rgb(248, 248, 249);
  color: rgb(115, 128, 147);
  font-family: "Gilroy", "Open Sans", "OpenSans", Arial, "Helvetica Neue", Helvetica,sans-serif;
  display: flex;
  flex-direction: column;
  padding: 6px;
  border-radius: 6px;

  &:empty {
    display: none;
  }

  @media (min-width: 420px) {
    flex-direction: row;
  }
`;

export function Cell({ children }: { children: Node }): Node {
  return (
    <CellWrap>
      <CellCenter>
        {children}
      </CellCenter>
    </CellWrap>
  );
}

export const CellWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  border-bottom: 1px solid rgba(203, 203, 203, 0.5);
  padding: 12px;

  &:last-child {
    border: none;
  }

  @media (min-width: 420px) {
    flex-grow: 1;
    flex-basis: 0;
    border-right: 1px solid rgba(203, 203, 203, 0.5);
    border-bottom: none;
  }
`;

const CellCenter = styled.div``;

export const Title = styled.div`
  font-size: 1.1em;
  opacity: .8;
  &:after {
    content: ':';
  }
`;

export const Value = styled.div`
  font-size: 1.75em;
  display: flex;
  vertical-align: text-bottom;
  align-items: baseline;
`;

export const ValueSmall = styled.span`
  font-size: 0.5em;
  font-weight: normal;
  &:before { content: '('; }
  &:after { content: ')'; }
  text-transform: capitalize;
  opacity: .5;
`;

export const ValueSeparator = styled.div`
  width: 6px;
  height: 1px;
`;
